<div class="header">
  <div class="title">{{ data?.level ? data.level + '次承認者選択' : '承認者選択' }}</div>
</div>
<mat-dialog-content class="dialog-content" autofocus>
  @if (showSpinner) {
    <div class="spinner center">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
  <!-- 検索フォーム -->
  <div class="search-form">
    <!-- 役職 -->
    <div class="form-row">
      <label class="form-label">役職</label>
      <mat-form-field appearance="outline" class="position-select">
        <mat-select [(ngModel)]="selectedPosition" (selectionChange)="onSearch()">
          <mat-option [value]="null"></mat-option>
          @for (pos of officialPositions; track pos.value) {
            <mat-option [value]="pos.value">
              {{ pos.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- 名前 -->
    <div class="form-row">
      <label class="form-label">名前</label>
      <div class="name-inputs">
        <input
          type="text"
          class="name-input"
          [(ngModel)]="lastName"
          placeholder="姓"
          (blur)="onSearch()"
          (keydown.enter)="onEnter($event)"
        />
        <input
          type="text"
          class="name-input"
          [(ngModel)]="firstName"
          placeholder="名"
          (blur)="onSearch()"
          (keydown.enter)="onEnter($event)"
        />
      </div>
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-- 検索結果 -->
  <div class="search-results">
    <!-- スピナー -->
    @if (isSearching) {
      <div class="results-spinner">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }

    <!-- 結果一覧 -->
    @if (!isSearching && hasSearched) {
      <div class="results-list">
        @for (approver of searchResults; track $index) {
          <div
            class="result-item"
            [class.selected]="isSelected(approver)"
            (click)="toggleApprover(approver)"
          >
              <mat-checkbox
                class="thin-checkbox"
                [checked]="isSelected(approver)"
                (click)="$event.stopPropagation()"
                (change)="toggleApprover(approver)"
              />
            <div class="approver-details">
              @if(approver.position){
                <div class="approver-name">{{ approver.position }}　{{ approver.name }}</div>
              } @else {
                <div class="approver-name">{{ approver.name }}</div>
              }
              <div class="approver-affiliations">
                @for (affiliation of approver.affiliations; track $index) {
                  <div class="affiliation-row">
                    <div class="dot">・</div>
                    <div>{{ affiliation }}</div>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <!-- 結果なし -->
        @if (searchResults && searchResults.length == 0) {
          <div class="no-results">
            該当する承認者が見つかりません。
          </div>
        }
      </div>
    }
  </div>
}
</mat-dialog-content>

<mat-dialog-actions align="end" class="actions-content">
  <button mat-raised-button (click)="onCancel()">キャンセル</button>
  <button mat-raised-button (click)="onSelect()" class="yes-btn">選択</button>
</mat-dialog-actions>
